import { Download } from 'lucide-react';
import { type ReactElement } from 'react';
import { Badge } from '@avanta/shared/components/ui/Badge';
import { type MessageFile } from '@avanta/shared/types/chat';

export const FileMessage = ({ file }: MessageFile): ReactElement => (
  <a href={file.url} target="_blank" rel="noopener noreferrer" className="block">
    <Badge
      size="sm"
      className="cursor-pointer rounded-sm bg-white text-denim-600 border border-plum-200 h-8 p-4 flex items-center gap-2 hover:bg-gray-100 text-sm w-full "
    >
      {file.name}
      <Download className="size-4" />
    </Badge>
  </a>
);

export const ImageMessage = ({ file }: MessageFile): ReactElement => (
  <a href={file.url} target="_blank" rel="noopener noreferrer" className="block">
    <img
      src={file.url}
      alt={file.name}
      className="w-80 h-60 object-cover rounded shadow-sm hover:opacity-80 transition"
    />
  </a>
);

export const VideoMessage = ({ file }: MessageFile): ReactElement => (
  <video src={file.url} controls className="w-80 h-60 rounded shadow-sm" preload="metadata">
    <track kind="captions" />
  </video>
);
